import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TGetClientInfoRes } from 'api/swagger';
import { CLIENT_APP_CLIENT_USER_INFO } from 'client-app/api/query-keys';

export const useGetClientInfo = (enabled: boolean = true) => {
  return useQuery<TGetClientInfoRes>({
    queryKey: [CLIENT_APP_CLIENT_USER_INFO],
    queryFn: async () => {
      const { data } = await http.get<TGetClientInfoRes>('client-office/v1/client');
      return data;
    },
    retry: 2,
    enabled,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60,
    staleTime: 1000 * 60 * 60,
  });
};
